import { z } from 'zod'
import { optionalText, requiredText } from '../../../lib/forms/rules'

/**
 * Toplantı Türü ekle/düzenle form şeması: TR ad zorunlu, EN ad opsiyonel. Sıra alanı **yoktur** —
 * tabloda `SORT_INDEX` kolonu açılmadı, liste ada göre gelir.
 */
export const meetingTypeFormSchema = z.object({
  nameTr: requiredText(),
  nameEn: optionalText(),
})

export type MeetingTypeFormValues = z.infer<typeof meetingTypeFormSchema>
